import { jsx as _jsx } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { GeographicMapDesktop } from "@faire/retailer-visitor-shared/components/GeographicMap/GeographicMapDesktop";
import { GeographicMapMobile } from "@faire/retailer-visitor-shared/components/GeographicMap/GeographicMapMobile";
// eslint-disable-next-line import/no-unassigned-import
import "@faire/retailer-visitor-shared/components/slick.css";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import { trackBrandLeadsBrandsPageGeographicMapView } from "@faire/web-api--source/events/brandLeads/view/brandsPageGeographicMap";
import React from "react";
import styled from "styled-components";
export var GeographicMap = function(param) {
    var showCaseStudies = param.showCaseStudies;
    var isMobile = useViewport().isMobile;
    var ref = useDoActionWhenVisible(trackBrandLeadsBrandsPageGeographicMapView);
    return /*#__PURE__*/ _jsx(WhenVisibilityIsImminent, {
        children: /*#__PURE__*/ _jsx(Container, {
            ref: ref,
            $showCaseStudies: showCaseStudies,
            children: isMobile ? /*#__PURE__*/ _jsx(GeographicMapMobile, {}) : /*#__PURE__*/ _jsx(GeographicMapDesktop, {})
        })
    });
};
var Container = styled(Column).withConfig({
    componentId: "sc-89920f8a-0"
})([
    "width:100%;background-color:",
    ";padding:",
    ";",
    "{padding:",
    ";background-color:",
    ";}"
], function(param) {
    var $showCaseStudies = param.$showCaseStudies;
    return $showCaseStudies ? Core.surface.inverse : Decorative.tint.neutral;
}, getSpacing("8x"), responsiveMediaQueries.mobile, getSpacing("3x", 0), Core.surface.inverse);
